export const TailorPage = () => {
  return <div className="relative flex h-[700px] gap-6" />;
};
